import { DrawerHeader } from '@one-thd/sui-atomic-components';
import React from 'react';
import { usePTCDocumentsContext } from '../../../hooks/useContexts';
export var PTCDocumentDrawerHeader = function () {
    var _a = usePTCDocumentsContext(), selectedDocument = _a.selectedDocument, handleCloseDrawer = _a.handleCloseDrawer;
    var ptcDrawerTitle = selectedDocument
        ? selectedDocument.pdfName.replace(/\.pdf$/i, '')
        : 'View Pro Trade Credit Documents';
    return React.createElement(DrawerHeader, { title: ptcDrawerTitle, onClose: handleCloseDrawer });
};
